import useAppDispatch from '../../hooks/useAppDispatch'
import useAppSelector from '../../hooks/useAppSelector'
import {
  getIsNewAppVersionAvailableSelector,
  setIsNewVersionUpdateAvailable,
} from '../../features/serviceWorker/serviceWorkerSlice'
import CheckinAlertDialog from '../common/CheckinAlertDialog'
import useBroadcastChannel from '../../hooks/useBroadcastChannel'

const NewAppVersionModal = () => {
  const dispatch = useAppDispatch()
  const isNewAppVersionAvailable = useAppSelector(getIsNewAppVersionAvailableSelector)

  const { refreshAppTabs } = useBroadcastChannel('app-update')

  const onServiceWorkerControllerChange = () => {
    navigator.serviceWorker.removeEventListener('controllerchange', onServiceWorkerControllerChange)
    console.log('New controller activated')
    dispatch(setIsNewVersionUpdateAvailable(false))
    refreshAppTabs()
  }

  const handleUpdate = () => {
    navigator.serviceWorker.addEventListener('controllerchange', onServiceWorkerControllerChange)
    navigator.serviceWorker.getRegistrations()
      .then(async (registrations) => {
        const promises = registrations.map(reg => {
          return reg.waiting
            ? reg.waiting.postMessage({ type: 'SKIP_WAITING' })
            : Promise.resolve()
        })

        await Promise.all(promises)
      })
      .catch((err) => {
        console.error('Error while updating service worker registrations:', err)
        navigator.serviceWorker.removeEventListener('controllerchange', onServiceWorkerControllerChange)
      })
  }

  return (
    <CheckinAlertDialog
      open={isNewAppVersionAvailable}
      text={'New Version available! Click "Update Now" to refresh the page and apply the latest changes.'}
      yesActions={[{ label: 'Update Now', onClick: handleUpdate }]}
    />
  )
}

export default NewAppVersionModal
